import { jsx as _jsx } from "react/jsx-runtime";
import { useDeactivateVenueFromTeam, useListTeamHomeVenues, useRemoveVenueFromTeam, } from "../api/TeamVenueApiProvider";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { useNumericParams } from "../utils/useNumericParams";
import { ManageVenueAssociations } from "../venues/ManageVenueAssociations";
export var ManageTeamVenues = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveTeam({ id: id }), team = _a.data, isLoading = _a.isLoading, error = _a.error;
    var _b = useRetrieveUserTeamPermissions({
        teamId: id,
    }), permissions = _b.data, isPermsLoading = _b.isLoading, permsError = _b.error;
    var _c = permissions || {}, _d = _c.canView, canView = _d === void 0 ? false : _d, _e = _c.canModify, canModify = _e === void 0 ? false : _e;
    var _f = useListTeamHomeVenues({ teamId: id, enabled: canView }), venues = _f.data, isVenuesLoading = _f.isLoading, venuesError = _f.error;
    var deactivateMutation = useDeactivateVenueFromTeam({
        teamId: id,
        onSuccess: function () { },
        onError: function () { },
    });
    var removeMutation = useRemoveVenueFromTeam({
        teamId: id,
        onSuccess: function () { },
        onError: function () { },
    });
    var handleDeactivate = function (venueAssociationId, toDate) {
        deactivateMutation.mutate({
            teamVenueId: venueAssociationId,
            toDate: toDate,
        });
    };
    var handleRemove = function (venueAssociationId) {
        removeMutation.mutate(venueAssociationId);
    };
    if (!id) {
        return _jsx(NotFound, {});
    }
    if (isLoading || isPermsLoading || isVenuesLoading) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (error || !team || permsError || venuesError) {
        return (_jsx(ErrorView, { error: error ||
                permsError ||
                venuesError ||
                new Error("Failed to load team or venues.") }));
    }
    return (_jsx(ManageVenueAssociations, { entityName: "team", entityDisplayName: team.name, entityId: id, venues: venues || [], addVenueUrl: "/teams/".concat(id, "/venues/add/"), deactivateMutation: deactivateMutation, removeMutation: removeMutation, onDeactivate: handleDeactivate, onRemove: handleRemove }));
};
